var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100vh","border":"none","overflow":"hidden"}},[_c('iframe',{ref:"iframeWin",staticStyle:{"width":"100%","height":"100%","border":"none"},attrs:{"allowfullscreen":"true","id":"iframe","src":_vm.webSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }